import { TableCell, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as DeleteIcon } from "assets/icons/deleteIcon.svg";
import HtmlTooltip from "components/Elements/HtmlTooltip";
import { isoDateWithoutTimeZone } from "helpers/utils";

const NoteRow = ({ row, classes, onDeleteNote, onEditNote, onViewNote, isReadOnly }) => {
	const { t } = useTranslation();
	return (
		<TableRow>
			<TableCell style={{ width: "170px" }}>{row.name}</TableCell>
			<TableCell style={{ width: "100px" }}>
				{isoDateWithoutTimeZone(row.date + "Z")}
			</TableCell>
			<TableCell className="note-field" style={{ whiteSpace: "unset", maxWidth: "300px" }}>
				<HtmlTooltip
					title={<div dangerouslySetInnerHTML={{ __html: row.note || "" }} />}
				>
					<div
						className="max-two-line"
						dangerouslySetInnerHTML={{ __html: row.note || "" }}
					/>
				</HtmlTooltip>
			</TableCell>
			<TableCell>
				<div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
					<p className="new-link" onClick={() => onViewNote(row.note)}>
						{t("action.view")}
					</p>
					{!isReadOnly && (
						<p className="new-link" onClick={() => onEditNote(row)}>
							{t("action.edit")}
						</p>
					)}
				</div>
			</TableCell>
			<TableCell style={{ width: "50px" }}>
				{isReadOnly ? null : (
					<DeleteIcon
						className={classes.deleteIcon}
						onClick={() => onDeleteNote(row.id)}
					/>
				)}
			</TableCell>
		</TableRow>
	);
};

export default NoteRow;
